var exports = {
  "iU": "Message.module__message___UVVtRW",
  "Ph": "Message.module__messagePreviewSpacing___UVVtRW",
  "IL": "Message.module__messagePreview___UVVtRW",
  "uK": "Message.module__focusRingAnchor___UVVtRW",
  "J8": "Message.module__messageCompact___UVVtRW",
  "Xo": "Message.module__messageHovered___UVVtRW",
  "L8": "Message.module__messageMentioned___UVVtRW",
  "m6": "Message.module__messageReplying___UVVtRW",
  "O6": "Message.module__messageHighlight___UVVtRW",
  "lY": "Message.module__contextMenuActive___UVVtRW",
  "Bc": "Message.module__mobileLayout___UVVtRW",
  "p2": "Message.module__messageLongPress___UVVtRW",
  "Uw": "Message.module__messageGrouped___UVVtRW",
  "kT": "Message.module__messageEditing___UVVtRW",
  "E4": "Message.module__messageSent___UVVtRW",
  "mr": "Message.module__messageSending___UVVtRW",
  "b$": "Message.module__messageFailed___UVVtRW",
  "RZ": "Message.module__failedFooter___UVVtRW",
  "Iu": "Message.module__failedFooterMessage___UVVtRW",
  "bg": "Message.module__failedFooterLabel___UVVtRW",
  "OZ": "Message.module__failedFooterIcon___UVVtRW",
  "dv": "Message.module__failedRetryIcon___UVVtRW",
  "QW": "Message.module__failedRetryButton___UVVtRW",
  "q5": "Message.module__messageGutterLeft___UVVtRW",
  "ZN": "Message.module__messageGutterRight___UVVtRW",
  "$7": "Message.module__messageAvatar___UVVtRW",
  "CW": "Message.module__messageNoText___UVVtRW",
  "U7": "Message.module__messageContent___UVVtRW",
  "rO": "Message.module__messageAuthorInfo___UVVtRW",
  "xW": "Message.module__jumpHeading___UVVtRW",
  "RO": "Message.module__jumpHeadingButton___UVVtRW",
  "dw": "Message.module__messageAuthorRow___UVVtRW",
  "AY": "Message.module__messageAuthorPart___UVVtRW",
  "x": "Message.module__userTagOffset___UVVtRW",
  "oL": "Message.module__messageTimestamp___UVVtRW",
  "BK": "Message.module__authorDashSeparator___UVVtRW",
  "um": "Message.module__messageUsername___UVVtRW",
  "Lo": "Message.module__messageText___UVVtRW",
  "L5": "Message.module__messageTimestampCompact___UVVtRW",
  "tQ": "Message.module__compactAuthorPrefix___UVVtRW",
  "U6": "Message.module__copyOnly___UVVtRW",
  "Mz": "Message.module__compactInlineContent___UVVtRW",
  "aM": "Message.module__systemMessageContent___UVVtRW",
  "vp": "Message.module__contextMenuUnderline___UVVtRW",
  "aE": "Message.module__messageTimeoutIndicator___UVVtRW",
  "t4": "Message.module__textSeparator___UVVtRW",
  "KL": "Message.module__messageTimestampHover___UVVtRW",
  "jh": "Message.module__messageTimestampCompactHover___UVVtRW",
  "iZ": "Message.module__messageAvatarCompact___UVVtRW",
  "kq": "Message.module__compactContentWrapper___UVVtRW",
  "xv": "Message.module__hoverAction___UVVtRW",
  "kL": "Message.module__container___UVVtRW",
  "tI": "Message.module__repliedMessage___UVVtRW",
  "_T": "Message.module__repliedMessageCompact___UVVtRW",
  "$y": "Message.module__repliedTextPreview___UVVtRW",
  "NL": "Message.module__repliedAvatar___UVVtRW",
  "a3": "Message.module__repliedIconContainer___UVVtRW",
  "Pq": "Message.module__repliedIcon___UVVtRW",
  "EK": "Message.module__repliedUsername___UVVtRW",
  "IQ": "Message.module__repliedItalic___UVVtRW",
  "t": "Message.module__unstyled___UVVtRW",
  "Io": "Message.module__repliedTextContent___UVVtRW",
  "c": "Message.module__systemMessageFollowsSystem___UVVtRW",
  "Hj": "Message.module__systemMessageIconWrapper___UVVtRW",
  "Po": "Message.module__systemMessageIconCompact___UVVtRW",
  "jJ": "Message.module__systemMessageTimestamp___UVVtRW",
  "rc": "Message.module__systemMessageContentWrapper___UVVtRW",
  "V_": "Message.module__systemMessageCompactContent___UVVtRW",
  "Gq": "Message.module__systemMessageIconSvg___UVVtRW",
  "hr": "Message.module__systemMessageLink___UVVtRW",
  "ll": "Message.module__userTagCompact___UVVtRW",
  "O4": "Message.module__editedTimestamp___UVVtRW",
  "k8": "Message.module__editedLabel___UVVtRW",
  "zX": "Message.module__typingContainer___UVVtRW",
  "Y9": "Message.module__typingCluster___UVVtRW",
  "RL": "Message.module__typingIndicator___UVVtRW",
  "Kl": "Message.module__typingAvatarContainer___UVVtRW",
  "tY": "Message.module__typingText___UVVtRW",
  "AZ": "Message.module__typingClusterComposerStatus___UVVtRW",
  "am": "Message.module__compactContentNoPrefix___UVVtRW",
  "Ys": "Message.module__compactBody___UVVtRW",
  "Ac": "Message.module__unknownMessageCompactContent___UVVtRW",
  "qU": "Message.module__unknownMessageWarning___UVVtRW",
  "NG": "Message.module__keyboardFocused___UVVtRW",
  "an": "Message.module__messageClientSystem___UVVtRW",
  "og": "Message.module__systemMessageContainer___UVVtRW",
  "Is": "Message.module__systemMessageIcon___UVVtRW",
  "ry": "Message.module__mediaFocusRing___UVVtRW",
  "xS": "Message.module__systemMessageDismissButton___UVVtRW",
  "Eu": "Message.module__silentMessageIcon___UVVtRW",
};

module.exports = exports;
